import styled from "styled-components";
import { styled as muiStyled } from '@mui/material/styles';
import { Box } from "@mui/material";
import { error } from "styles/theme";

export const AvatarCellStyles = muiStyled(Box)(({ }) => ({
    '.avatar-img': {
        width: 35,
        height: 35
    }
}));

export const EditButtonStyles = muiStyled(Box)(({ }) => ({
    '.MuiButtonBase-root.MuiIconButton-root': {
        borderRadius: 8
    },
    '.invalid-label': {
        fontSize: 16,
        color: error

    },
    '.invalid': {
        color: error
    }
}));

export const WrapWarningCell = styled.div`

`

export const TestTakerDetails = styled.div`
font-size:16px;
`